import { NavigationExtras } from '@angular/router';

import { RouterErrorAction, ROUTER_ERROR as RouterError } from '@ngrx/router-store';
import { Action } from '@ngrx/store';

export enum RouterActionTypes {
  Go = '[Router] Go',
  Back = '[Router] Back',
  Forward = '[Router] Forward',
  UpdateLocation = '[Router] Update Location',
}

export interface RouterPayload {
  commands: (string | number)[];
  extras?: NavigationExtras;
}

export class Go implements Action {
  readonly type = RouterActionTypes.Go;

  constructor(public payload: RouterPayload) {}
}

export class UpdateLocation implements Action {
  readonly type = RouterActionTypes.UpdateLocation;

  constructor(public payload: RouterPayload) {}
}

export class Back implements Action {
  readonly type = RouterActionTypes.Back;
}

export class Forward implements Action {
  readonly type = RouterActionTypes.Forward;
}

export type RouterActions = Go | Back | Forward | UpdateLocation;

export { RouterError, RouterErrorAction };
